import * as React from 'react';
import './Project.css';
import { ClassNames } from 'src/_helpers/ClassNames';
import ProjectImages from '../ProjectImages/ProjectImages';
import ProjectText from '../ProjectText/ProjectText';

export type ProjectProps = ProjectDto;

export class Project extends React.Component<ProjectProps> {
    constructor(props: ProjectProps) {
        super(props);
    }
    render() {
        const { Leaves } = this.props;

        return (
            <div className={ClassNames('project', '')}>
                {Leaves.map((leaf, i) =>
                    <React.Fragment key={i}>
                        {
                            leaf.type === "ProjectImages" &&
                            <ProjectImages {...leaf as ProjectImagesDto} />
                        }
                        {
                            leaf.type === "ProjectText" &&
                            <ProjectText {...leaf as ProjectTextDto} />
                        }
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default Project;


// WEBPACK FOOTER //
// ./src/Components/Project/Project.tsx